import React from 'react'
import { Link } from 'gatsby'
import Layout from '../components/Layout'

// uncomment for local testing

/*if (typeof window !== 'undefined') window._authed = Promise.resolve({ 
  username: 'fake',
  hasRole: () => false,// true,
  hasApp: () => true,
  ['app-hierarchies']: {'advising-report':'UA/NU'}
 })*/



const IndexPage = () => (
  <Layout>
    <h1>Advising Survey Reports</h1>
    <p>Available Years:</p>
    <ul>
      <li><Link to="/report/201810">Spring 2018</Link></li>
      <li><Link to="/report/201910">Spring 2019</Link></li>
      <li><Link to="/report/202010">Spring 2020</Link></li>
      <li><Link to="/report/202110">Spring 2021</Link></li>
      <li><Link to="/report/202210">Spring 2022</Link></li>
      <li><Link to="/report/202310">Spring 2023</Link></li>
      <li><Link to="/report/202410">Spring 2024</Link></li>
      <li><Link to="/report/202510">Spring 2025</Link></li>
      <li><Link to="/report/202610">Spring 2026</Link></li>
    </ul>
  </Layout>
)

export default IndexPage
